<template>
    <div style="overflow-x: auto">
        <table class="table b-table" id="tabela">
            <thead class="thead-dark">
                <tr>
                    <th class="text-center" rowspan="2">{{ titleName }}</th>
                    <th class="text-center" colspan="2">Totais</th>
                    <th class="text-center" rowspan="2">Ticket Médio</th>
                    <th class="text-center" :colspan="1 + quotes.length">Comissões</th>
                    <th class="text-center" rowspan="2">Prêmio p/ Volume</th>
                    <th class="text-center" colspan="3">Totais</th>
                </tr>
                <tr>
                    <th class="text-center">Cotas</th>
                    <th class="text-center">Vendas</th>
                    <th class="text-center" v-for="quote in quotes">{{ quote }}ª Parcela</th>
                    <th class="text-center">Estorno</th>
                    <th class="text-center">Comissão</th>
                    <th class="text-center">Prêmio por Volume</th>
                    <th class="text-center">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items">
                    <td>{{ item.name }}</td>
                    <td class="text-center">{{ item.quotes }}</td>
                    <td class="text-center">R${{ item.sales | price }}</td>
                    <td class="text-center">R${{ item.sales / Math.max(item.quotes, 1) | price }}</td>
                    <td class="text-center" v-for="quote in quotes">R${{ item.commissions.quotes[quote + "_quote"] | price }}</td>
                    <td class="text-center">R${{ item.commissions.chargeback | price }}</td>
                    <td class="text-center">R${{ item.commissions.byVolume | price }}</td>
                    <td class="text-center">R${{ item.commissions.contemplation + item.commissions.group + item.commissions.deployment + reduce(item.commissions.quotes) | price }}</td>
                    <td class="text-center">R${{ item.commissions.byVolume | price }}</td>
                    <td class="text-center">R${{ item.commissions.contemplation + item.commissions.group + item.commissions.deployment + reduce(item.commissions.quotes) + item.commissions.byVolume | price }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr role="row">
                    <td role="columnheader" scope="col"><strong>Totais</strong></td>
                    <td class="text-center">{{ sum(items, 'quotes') }}</td>
                    <td class="text-center">R${{ sum(items, 'sales') | price }}</td>
                    <td class="text-center">R${{ sum(items, 'sales') / Math.max(sum(items, 'quotes'), 1) | price }}</td>
                    <td class="text-center" v-for="quote in quotes">R${{ sumInstallmentCommissions(items, quote + "_quote") | price }}</td>
                    <td class="text-center">R${{ sumCommissions(items, 'chargeback') | price }}</td>
                    <td class="text-center">R${{ sumCommissions(items, 'byVolume') | price }}</td>
                    <td class="text-center">R${{ sumCommissions(items, 'contemplation') + sumCommissions(items, 'group') + sumCommissions(items, 'deployment') + sumInstallmentCommissions(items) | price }}</td>
                    <td class="text-center">R${{ sumCommissions(items, 'byVolume') | price }}</td>
                    <td class="text-center">R${{ sumCommissions(items, 'contemplation') + sumCommissions(items, 'group') + sumCommissions(items, 'deployment') + sumInstallmentCommissions(items)  + sumCommissions(items, 'byVolume') | price }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                quotes: []
            };
        },
        mounted() {
            var self = this;
            var items = self.items;
            if (items.length > 0) {
                var item = items[0];

                Object.keys(item.commissions.quotes).forEach(function (_key) {
                    var installment = _key.substr(0, _key.indexOf('_'));
                    self.quotes.push(installment);
                });
            }
        },
        methods: {
            reduce(_quote) {
                var self = this;
                var sum = 0;

                self.quotes.forEach(function (_item) {
                    sum += _quote[_item + "_quote"];
                });

                return sum;
            },
            sum(_proposals, _reducer) {
                var sum = 0;

                _proposals.forEach(function (_proposal) {
                    sum += parseFloat(_proposal[_reducer]);
                });

                return sum;
            },
            sumCommissions(_items, _field) {
                var sum = 0;

                _items.forEach(function (_item) {
                    sum += parseFloat(_item.commissions[_field]);
                });

                return sum;
            },
            sumInstallmentCommissions(_items, _installment) {
                var self = this;
                var sum = 0;

                _items.forEach(function (_item) {
                    if (_installment) {
                        sum += _item.commissions.quotes[_installment];
                        return;
                    }
                    sum += self.reduce(_item.commissions.quotes);
                });

                return sum;
            }
        },
        props: ['items', 'titleName']
    }
</script>
<style scoped>
    .md-table {
        margin-bottom: 30px;
    }
</style>